import { Breadcrumb } from 'peach/components'
import { Switch, Route, Redirect } from 'peach/router'

import CompanyRoutes from './CompanyRoutes'
import { ErrorBoundary } from './errors'
import WrongEnvFallback from './errors/WrongEnvFallback'

const CompaniesRoutes = () => (
  <>
    <Breadcrumb to='/companies' />
    <Switch>
      <Route path='/companies/:companyId'>
        <ErrorBoundary
          fallback={(props: any) => <WrongEnvFallback {...props} />}
        >
          <CompanyRoutes />
        </ErrorBoundary>
      </Route>

      <Redirect to='/companies' />
    </Switch>
  </>
)

export default CompaniesRoutes
